'use strict';

angular.module('magview')
    .controller('generalCtrl', [
        '$scope', 'generalViewModel',
        function ($scope, viewModel) {
            $scope.model = new viewModel($scope.pref);
        }
    ]);
